<template>
  <div class="blog-card-cover" :class="image ? 'blog-card-cover--photo' : 'blog-card-cover--' + theme">
    <img
      v-if="image"
      class="blog-card-cover__photo"
      :src="image"
      :alt="alt"
      width="280"
      height="158"
      loading="lazy"
    />
    <template v-else>
      <span class="blog-card-cover__label">{{ label }}</span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'BlogCardCover',
  props: {
    theme: { type: String, default: 'safe' },
    label: { type: String, default: '' },
    image: { type: String, default: '' },
    alt: { type: String, default: 'GB WhatsApp blog article' },
  },
}
</script>
